<template>
  <div class="list">
    <AmenityItem v-for="item in list"
      :key="item.raCode"
      :lang="lang"
      :locale="locale"
      :localeAmenity="localeAmenity"
      :item="item"
      :roomKey="roomKey" />
  </div>
</template>

<script>
import AmenityItem from '@/components/Amenity/AmenityItem.vue'

export default {
  name: 'AmenityList',
  props: [
    'lang',
    'locale',
    'list',
    'roomKey',
    'localeAmenity'
  ],
  components: {
    AmenityItem
  }
}
</script>
